
const digest = '126b6356c4348284fa2a84eeeaeadf3135d7bd8fae45817993b2028939438211';
const classes = {"wrapper":"_wrapper_7p7f6_1"};
const css = `._wrapper_7p7f6_1 {
  background-color: #E9EFFD;
  padding: 34px 24px;
  margin: -34px -24px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  